import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { forwardRef, useEffect, useRef, useState, useCallback, useMemo, } from "react";
import { CalendarContainer, ContentBody, ContentFooter, DatePickerContent, DatePickerTrigger, DatePickerWrapper, StyledCalendar, DayButton, MonthYearHeader, FilterIntervalDiary, ContainerTime, ContainerLengthTime, SliderContainer, Range, Thumb, TextHour, DateTriggerText, DateTriggerLabel, } from "./styles";
import { addMonths, compareAsc, eachDayOfInterval, endOfDay, endOfMonth, format, isAfter, isBefore, isSameDay, startOfDay, startOfMonth, subMonths, } from "date-fns";
import { Button } from "../Button";
import { fillDaysArray } from "../../utils/functions";
import { ptBR } from "date-fns/locale";
import { CalendarInputs, CalendarOptions, TimeInput, } from "./CalendarComponents";
import { Spinner } from "../Spinner";
import { useTheme } from "styled-components";
import { IconArrowDropDown, IconCalendarCheck } from "../icons";
import { createPortal } from "react-dom";
import { Checkbox } from "../Checkbox";
var firstAndLastItem = function (array) {
    return [array[0], array[array.length - 1]];
};
var DayButtonMemo = React.memo(DayButton);
export var CalendarDateFuture = forwardRef(function CalendarDateFuture(_a, ref) {
    var _b = _a.hideOptions, hideOptions = _b === void 0 ? [] : _b, hideAllOptions = _a.hideAllOptions, onlyDate = _a.onlyDate, onSelectDate = _a.onSelectDate, defaultDate = _a.defaultDate, isLoading = _a.isLoading, disabled = _a.disabled, minDate = _a.minDate, maxDate = _a.maxDate, value = _a.value, containerStyles = _a.containerStyles, useTimeRange = _a.useTimeRange, onFilterIntervalChange = _a.onFilterIntervalChange, dateLabel = _a.dateLabel, props = __rest(_a, ["hideOptions", "hideAllOptions", "onlyDate", "onSelectDate", "defaultDate", "isLoading", "disabled", "minDate", "maxDate", "value", "containerStyles", "useTimeRange", "onFilterIntervalChange", "dateLabel"]);
    var theme = useTheme();
    var _c = useState(false), show = _c[0], setShow = _c[1];
    var triggerRef = useRef(null);
    var modalRef = useRef(null);
    var _d = useState({ top: "0px", left: "0px" }), position = _d[0], setPosition = _d[1];
    var _e = useState(defaultDate || {
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
    }), selectedDate = _e[0], setSelectedDate = _e[1];
    var _f = useState(defaultDate || {
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
    }), dateOnButton = _f[0], setDateOnButton = _f[1];
    var toggleShow = useCallback(function () {
        setSelectedDate(dateOnButton);
        setShow(function (state) { return !state; });
    }, [dateOnButton]);
    var _g = useState(false), isSelecting = _g[0], setIsSelecting = _g[1];
    var _h = useState(null), dayHovered = _h[0], setDayHovered = _h[1];
    var _j = useState([]), hoveredDays = _j[0], setHoveredDays = _j[1];
    var _k = useState({
        start: startOfMonth(selectedDate.start),
        end: endOfMonth(selectedDate.start),
    }), monthToShow = _k[0], setMonthToShow = _k[1];
    var _l = firstAndLastItem(hoveredDays), firstItem = _l[0], lastItem = _l[1];
    var firstDay = useMemo(function () {
        return firstItem && compareAsc(firstItem, selectedDate.start) < 0
            ? firstItem
            : selectedDate.start;
    }, [firstItem, selectedDate.start]);
    var lastDay = useMemo(function () {
        return lastItem && compareAsc(lastItem, selectedDate.start) > 0
            ? lastItem
            : selectedDate.end;
    }, [lastItem, selectedDate.start, selectedDate.end]);
    var onClickDay = useCallback(function (day) {
        setHoveredDays([]);
        if (!isSelecting) {
            setIsSelecting(true);
            setSelectedDate({
                start: startOfDay(day),
                end: endOfDay(day),
            });
            return;
        }
        if (compareAsc(day, selectedDate.start) > 0) {
            setSelectedDate({
                start: selectedDate.start,
                end: endOfDay(day),
            });
        }
        else {
            setSelectedDate({
                start: startOfDay(day),
                end: selectedDate.end,
            });
        }
        setIsSelecting(false);
    }, [isSelecting, selectedDate]);
    var daysToShowMemo = useMemo(function () {
        var daysOfTheMonth = eachDayOfInterval(monthToShow);
        fillDaysArray(daysOfTheMonth);
        return daysOfTheMonth.map(function (day) { return ({
            value: day,
            day: day.getDate(),
            month: day.getMonth(),
            year: day.getFullYear(),
            weekday: day.getDay(),
        }); });
    }, [monthToShow]);
    var SLIDER_WIDTH = !hideAllOptions ? Number(250) : Number(90); //definindo largura do slider em px
    var hoursToTime = function (h) {
        var hours = Math.floor(h);
        var minutes = Math.round((h - hours) * 60);
        return "".concat(String(hours).padStart(2, "0"), ":").concat(String(minutes).padStart(2, "0"));
    };
    var timeToHours = function (date) {
        return date ? date.getHours() + date.getMinutes() / 60 : 0;
    };
    var _m = useState(false), filterInterval = _m[0], setFilterInterval = _m[1];
    var _o = useState(timeToHours(selectedDate.start)), min = _o[0], setMin = _o[1];
    var _p = useState(timeToHours(selectedDate.end)), max = _p[0], setMax = _p[1];
    var getThumbLeft = function (value) {
        var sliderWidth = SLIDER_WIDTH;
        return (value / 24) * sliderWidth;
    };
    var handleSelectDate = useCallback(function (date) {
        onSelectDate === null || onSelectDate === void 0 ? void 0 : onSelectDate(date);
        setDateOnButton(date);
        onFilterIntervalChange === null || onFilterIntervalChange === void 0 ? void 0 : onFilterIntervalChange(filterInterval);
        toggleShow();
    }, [onSelectDate, toggleShow, filterInterval, onFilterIntervalChange]);
    useEffect(function () {
        if (show) {
            setMin(timeToHours(selectedDate.start));
            setMax(timeToHours(selectedDate.end));
        }
    }, [show, selectedDate.start, selectedDate.end]);
    var _q = useState(null), activeThumb = _q[0], setActiveThumb = _q[1];
    var updateDateBoundary = function (type, rawValue) {
        var value = rawValue;
        if (type === "start") {
            value = Math.min(value, max - 0.25);
            setMin(value);
            var startDate = new Date(selectedDate.start);
            var hours = Math.floor(value);
            var minutes = Math.round((value - hours) * 60);
            startDate.setHours(hours, minutes, 0, 0);
            setSelectedDate({ start: startDate, end: selectedDate.end });
            setActiveThumb("min");
        }
        else {
            value = Math.min(value, 23.99);
            value = Math.max(value, min + 0.25);
            setMax(value);
            var endDate = new Date(selectedDate.end);
            var hours = Math.floor(value);
            var minutes = Math.round((value - hours) * 60);
            endDate.setHours(hours, minutes, 0, 0);
            setSelectedDate({ start: selectedDate.start, end: endDate });
            setActiveThumb("max");
        }
    };
    useEffect(function () {
        if (!dayHovered) {
            return;
        }
        if (compareAsc(dayHovered, selectedDate.start) > 0) {
            setHoveredDays(eachDayOfInterval({ start: selectedDate.start, end: dayHovered }));
        }
        else {
            setHoveredDays(eachDayOfInterval({ start: dayHovered, end: selectedDate.end }));
        }
    }, [dayHovered]);
    useEffect(function () {
        if (show && modalRef.current && triggerRef.current) {
            var modalRect = modalRef.current.getBoundingClientRect();
            var triggerRect = triggerRef.current.getBoundingClientRect();
            var windowHeight = window.innerHeight;
            var leftPosition = triggerRect.left + triggerRect.width + 4;
            if (triggerRect.right - modalRect.width < 0) {
                leftPosition = 4 + modalRect.width;
            }
            var topPosition = triggerRect.bottom + modalRect.height > windowHeight
                ? triggerRect.top - modalRect.height - 4
                : triggerRect.top + triggerRect.height + 4;
            setPosition({
                left: "".concat(leftPosition, "px"),
                top: "".concat(topPosition, "px"),
            });
        }
        else {
            setPosition({
                top: "0px",
                left: "0px",
            });
        }
    }, [show]);
    useEffect(function () {
        if (value) {
            setDateOnButton(value);
            setSelectedDate(value);
        }
    }, [value]);
    var handleClickOutside = useCallback(function (event) {
        if (modalRef.current &&
            triggerRef.current &&
            !modalRef.current.contains(event.target) &&
            !triggerRef.current.contains(event.target)) {
            setShow(false);
        }
    }, []);
    useEffect(function () {
        window.addEventListener("click", handleClickOutside);
        return function () {
            window.removeEventListener("click", handleClickOutside);
        };
    }, [handleClickOutside]);
    useEffect(function () {
        setMonthToShow({
            start: startOfMonth(selectedDate.start),
            end: endOfMonth(selectedDate.start),
        });
    }, [selectedDate]);
    return (_jsxs(DatePickerWrapper, { style: containerStyles, ref: ref, children: [_jsxs(DatePickerTrigger, __assign({ type: "button", ref: triggerRef, onClick: function () {
                    toggleShow();
                }, disabled: disabled || isLoading }, props, { children: [_jsxs(DateTriggerText, { children: [dateLabel && _jsx(DateTriggerLabel, { children: dateLabel }), _jsxs("div", { children: [format(dateOnButton.start, !onlyDate
                                        ? "dd/MM/yyyy - HH:mm"
                                        : useTimeRange
                                            ? "dd/MM/yyyy - HH:mm"
                                            : "dd/MM/yyyy"), _jsx("span", { children: " a " }), format(dateOnButton.end, !onlyDate
                                        ? "dd/MM/yyyy - HH:mm"
                                        : useTimeRange
                                            ? "dd/MM/yyyy - HH:mm"
                                            : "dd/MM/yyyy")] })] }), isLoading ? (_jsx(Spinner, { size: 20, color: theme.colors.neutral.light })) : (_jsx(IconCalendarCheck, {}))] })), createPortal(_jsxs(DatePickerContent, { ref: modalRef, "$show": show, top: position.top, left: position.left, children: [_jsxs(ContentBody, { children: [!hideAllOptions && (_jsx(CalendarOptions, { hideOptions: hideOptions, setSelectedDate: setSelectedDate, handleSelectDate: handleSelectDate })), _jsxs(CalendarContainer, { children: [_jsxs(MonthYearHeader, { children: [_jsx(IconArrowDropDown, { style: { transform: "rotate(90deg)" }, onClick: function () {
                                                    var newMonth = subMonths(monthToShow.start, 1);
                                                    setMonthToShow({
                                                        start: startOfMonth(newMonth),
                                                        end: endOfMonth(newMonth),
                                                    });
                                                } }), _jsxs("span", { children: [format(monthToShow.start, "MMMM", { locale: ptBR }), ", ", format(monthToShow.start, "yyyy")] }), _jsx(IconArrowDropDown, { style: { transform: "rotate(-90deg)" }, onClick: function () {
                                                    var newMonth = addMonths(monthToShow.start, 1);
                                                    setMonthToShow({
                                                        start: startOfMonth(newMonth),
                                                        end: endOfMonth(newMonth),
                                                    });
                                                } })] }), _jsxs("ul", { children: [_jsx("li", { children: "D" }), _jsx("li", { children: "S" }), _jsx("li", { children: "T" }), _jsx("li", { children: "Q" }), _jsx("li", { children: "Q" }), _jsx("li", { children: "S" }), _jsx("li", { children: "S" })] }), _jsx(StyledCalendar, { children: daysToShowMemo.map(function (day) {
                                            return (_jsx(DayButtonMemo, { onClick: function () { return onClickDay(day.value); }, onMouseEnter: function () {
                                                    return isSelecting && setDayHovered(day.value);
                                                }, onMouseLeave: function () { return isSelecting && setDayHovered(null); }, "$isHovered": hoveredDays.some(function (hoveredDay) {
                                                    return hoveredDay && compareAsc(hoveredDay, day.value) === 0;
                                                }), "$isSelected": isAfter(endOfDay(day.value), selectedDate.start) &&
                                                    isBefore(day.value, selectedDate.end), "$isFirst": isSameDay(firstDay, day.value), "$isLast": isSameDay(lastDay, day.value), "$isThisMonth": day.month === monthToShow.start.getMonth(), disabled: (minDate && isBefore(day.value, minDate)) ||
                                                    (maxDate && isAfter(day.value, maxDate)), children: day.day }, day.value.toString()));
                                        }) }), !onlyDate && (_jsx(CalendarInputs, { selectedDate: selectedDate, setSelectedDate: setSelectedDate, setHoveredDays: setHoveredDays, disabled: filterInterval }))] })] }), useTimeRange && (_jsxs(FilterIntervalDiary, { allOptions: !hideAllOptions, children: [_jsx(Checkbox, { onChange: function (e) {
                                    setFilterInterval(e.target.checked);
                                }, description: filterInterval
                                    ? "Horário fixo aplicado a todos os dias selecionados."
                                    : "", label: "Filtrar por intervalo (Di\u00E1rio)" }), filterInterval && (_jsxs(_Fragment, { children: [_jsxs(ContainerTime, { style: { position: "relative" }, children: [_jsx(TimeInput, { type: "start", value: selectedDate.start, styled: {
                                                    position: "absolute",
                                                    left: "".concat(getThumbLeft(min), "px"),
                                                }, setValue: function (e) {
                                                    setHoveredDays([]);
                                                    setSelectedDate({ start: e, end: selectedDate.end });
                                                } }), _jsx(TimeInput, { type: "end", value: selectedDate.end, styled: {
                                                    position: "absolute",
                                                    left: "".concat(getThumbLeft(max - 24), "px"),
                                                }, setValue: function (e) {
                                                    setHoveredDays([]);
                                                    setSelectedDate({ start: selectedDate.start, end: e });
                                                } })] }), _jsx(ContainerLengthTime, { children: _jsxs(SliderContainer, { children: [_jsx(Range, { style: {
                                                        left: "".concat((min / 24) * 100, "%"),
                                                        right: "".concat(100 - (max / 24) * 100, "%"),
                                                    } }), _jsx(Thumb, { min: 0, max: 23.75, step: 0.25, value: min, onChange: function (e) {
                                                        return updateDateBoundary("start", Number(e.target.value));
                                                    }, style: { zIndex: activeThumb === "min" ? 3 : 2 } }), _jsx(Thumb, { min: 0, max: 24, step: 0.25, value: max, onChange: function (e) {
                                                        return updateDateBoundary("end", Number(e.target.value));
                                                    }, style: { zIndex: activeThumb === "max" ? 3 : 2 } })] }) }), _jsxs(TextHour, { children: ["Todos os dias de ", hoursToTime(min), " at\u00E9 ", hoursToTime(max)] })] }))] })), _jsx(ContentFooter, { children: _jsx(Button, { variant: "outlined", onClick: function () {
                                handleSelectDate(selectedDate);
                            }, children: "Aplicar" }) })] }), document.body)] }));
});
//# sourceMappingURL=index.js.map